<template>
  <!-- No visible template required -->
  <div></div>
</template>

<script>
import { WebsiteRoute } from '../../../router/website.js';
import JobseekerRoute from '../../../router/jobseekers2.js';
import EmployerRoute from '../../../router/employer2.js';

export default {
  name: 'CommonSiteNavigationSchemaComponent',
  data() {
    return {
     webUrl: process.env.VUE_APP_URL,
    };
  },
  methods: {
      getPublicPageUrls() {
        const allowedNames = [
            'jobseekers2',
            'allDailyPaidJoblisting',
            'allJobsListing',
            'ResumeBuilder',
            'employer2',
            'blog',
            'Rewards',
            'aboutUs',
            'homepage',
            'faq',
            'TermsConditions',
            'PrivacyPolicy',
            'ContactUs',
            'login',
            'signup'

        ];
  
        const allRoutes = [...JobseekerRoute, ...EmployerRoute, ...WebsiteRoute];
  
        return allRoutes
          .filter(route => allowedNames.includes(route.name) && !route.path.includes('#'))
          .sort((a, b) => allowedNames.indexOf(a.name) - allowedNames.indexOf(b.name)) // sort based on your order
          .map(route => ({
              name: this.formatName(route.name),
              url: this.webUrl + route.path
                  .replace(/^\/+/, '')         // Remove leading slash
                  .replace(/\/:.*?\?/g, '')   // Remove optional params like :category_id?
          }));
      },
      formatName: function(name) {
        // Convert camelCase or lowercase into "Title Case"
        if (name === 'homepage') {
            return 'Singapore Jobs';
        }
        if (name === 'jobseekers2') {
            return 'For Jobseeker';
        }
        if(name === 'employer2')
        {
          return 'For Employer';
        }
        if (name === 'allJobsListing') {
          return 'Full Time Jobs Singapore';
        }
        if(name === 'allDailyPaidJoblisting')
        {
          return 'Part Time Jobs Singapore';
        }
        if (name === 'TermsConditions') {
          return 'Terms of Service';
        }
        if(name === 'login'){
          return 'Log In'
        }
        if(name === 'signup'){
          return 'Register'
        }
        return name
            .replace(/([A-Z])/g, ' $1')  // Add space before capital letters
            .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
            .trim(); // Remove leading/trailing spaces
      },
      generateSiteNavigationSchema(){
          const oldScript = document.getElementById('common-site-navigation-schema');
          if (oldScript) {
              oldScript.remove();
          }
          const items = this.getPublicPageUrls();

          const navigationSchema = {
              "@context": "https://schema.org",
              "@type": "ItemList",
              itemListElement: items.map(item => ({
              "@type": "SiteNavigationElement",
              name: item.name,
              url: item.url
              }))
          };    
          const siteNavigationSchema = document.createElement('script');
          siteNavigationSchema.setAttribute('type', 'application/ld+json');
          siteNavigationSchema.setAttribute('id', 'common-site-navigation-schema'); // <-- Add ID
          siteNavigationSchema.text = JSON.stringify(navigationSchema, null, 2);
          document.head.appendChild(siteNavigationSchema);
      },
  },
  mounted() {
    this.generateSiteNavigationSchema();
  },
   watch: {
    // Watch for route changes
    $route() {
      this.generateSiteNavigationSchema(); // Re-run on each route change
    }
  },
};
</script>
